import axios from 'axios';
import config from '../config/config';

const api = axios.create({
    baseURL: config.apiURL
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    // Log apenas em desenvolvimento e apenas para debug (muito verbose)
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG_API === 'true') {
        console.log('Interceptor - Token:', token ? 'existe' : 'não existe');
    }
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        // Log apenas em desenvolvimento e apenas para debug (muito verbose)
        if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG_API === 'true') {
            console.log('Interceptor - Headers:', config.headers);
        }
    }
    return config;
});

// Interceptor para tratar erros
api.interceptors.response.use(
    response => response,
    error => {
        // Trata erro de rede (backend não está acessível)
        if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
            console.error('❌ Erro de conexão: O backend não está acessível.');
            console.error('   Verifique se o backend está rodando na porta correta.');
            console.error(`   URL esperada: ${api.defaults.baseURL}`);
            if (process.env.NODE_ENV === 'development') {
                console.error('   Em desenvolvimento, o backend deve estar em: http://localhost:5000');
            }
        }
        
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location = '/login';
        }
        
        // Trata bloqueio por horário (403 com motivo horario_bloqueado)
        if (error.response?.status === 403 && error.response?.data?.motivo === 'horario_bloqueado') {
            const { hora_inicio, hora_fim, hora_atual } = error.response.data;
            // Redireciona para tela de bloqueio
            window.location.href = `/bloqueio?motivo=horario_bloqueado&hora_inicio=${hora_inicio || '07:00'}&hora_fim=${hora_fim || '18:00'}&hora_atual=${hora_atual || ''}`;
            return Promise.reject(error);
        }
        
        return Promise.reject(error);
    }
);

export default api; 